var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseNote',_vm._g({attrs:{"id":"simple5","note":_vm.note,"selected":_vm.selected}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }